import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('profile', 'guardian-dependents');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'care_user',
  type: 'get',
  slug: ['care_role_relation_assignments'],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/profiles/get-guardian-dependents.js